import React from "react";

const Terms = () => {
  return (
    <div className="bg-slate-100 py-10 md:py-24">
      <div className="container mx-auto px-5 md:px-24">
        <div className="bg-white rounded-lg shadow p-10">
          <h5 className="font-bold md:text-4xl text-2xl text-center md:text-start">
            Privacy Policy for GreenGPT Crypto Token Project
          </h5>
          <div className="md:mt-10">
            <p className="md:text-lg mt-5 text-justify md:text-start">
              GreenGPT respects the privacy of its users and is committed to
              protecting their personal information. This Privacy Policy
              outlines how we collect, use, and disclose personal information in
              connection with our Ask to Earn service, AI blockchain-based
              service, auto-staking, and auto-burning features.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                1. Collection of Personal Information:
              </span>
              We collect personal information from users when they register for
              our platform, participate in Ask to Earn tasks, or use our AI
              blockchain-based services. This may include name, email address,
              and other contact information, as well as data related to
              environmental sustainability.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                2. Use of Personal Information:
              </span>
              We use personal information to provide our services, process
              transactions, and communicate with users. We may also use
              aggregated data to improve our platform and services.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                3. Disclosure of Personal Information:
              </span>
              We may share personal information with third-party service
              providers who assist us in providing our platform and services. We
              may also disclose personal information in response to a legal
              request or as required by law.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                4. Security of Personal Information:
              </span>
              We take reasonable steps to protect personal information from
              unauthorized access, use, or disclosure. However, we cannot
              guarantee absolute security, and users should take steps to
              protect their own personal information.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                5. Retention of Personal Information:
              </span>
              We retain personal information for as long as necessary to provide
              our services and comply with legal obligations.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">6. Compliance with Laws:</span>
              Users agree to comply with all applicable laws, regulations, and
              rules when using the GreenGPT platform, including but not limited
              to anti-money laundering (AML) and know-your-customer (KYC)
              requirements.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                7. Rights Regarding Personal Information:
              </span>
              Users have the right to access, correct, and delete their personal
              information, as well as to object to its processing or restrict
              its use.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">8. Marketing Communications:</span>
              Users may opt-out of receiving marketing communications from
              GreenGPT at any time.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">9. International Transfers:</span>
              Personal information may be transferred to and processed in
              countries other than the user's country of residence, which may
              have different data protection laws.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">10. Children's Privacy:</span>
              Our platform and services are not intended for use by children
              under the age of 13, and we do not knowingly collect personal
              information from children under 13.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                11. These Changes to this Privacy Policy:
              </span>
              We may update this Privacy Policy from time to time. Users are
              responsible for reviewing the most current version of the policy
              regularly.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              By using the GreenGPT platform, users consent to the collection,
              use, and disclosure of their personal information as described in
              this Privacy Policy. If you do not agree to this policy, please do
              not use the GreenGPT platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
